module.exports = __webpack_public_path__ + "static/media/xls.21969610.svg";